import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import { getToken } from '@/utils/auth';

function getBaseURL() {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (process.env.NODE_ENV === 'development' && /^https?:\/\//.test(baseApi)) {
    const { pathname } = new URL(baseApi);
    return pathname;
  }
  return baseApi;
}

const service = axios.create({
  baseURL: getBaseURL(),
  timeout: 120000,
});
service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers.common['Authorization'] = `Bearer ${getToken()}`;
    }
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status !== 200 && response.status !== 201) {
      if (res.code === 401) {
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload();
          });
        });
      }
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000,
      });
      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      return res;
    }
  },
  (error) => {
    const status = error.response && error.response.status;
    const data = error.response && error.response.data;
    // 後端錯誤訊息(NestJS message 可能為字串或陣列)
    let message = (data && data.message) || error.message;
    if (Array.isArray(message)) {
      message = message.join('、');
    }
    // 僅在 401(登入失效)時清除 token,其餘狀態碼(400 等)只提示錯誤,不登出
    if (status === 401) {
      message = '登入錯誤';
      store.dispatch('user/resetToken').then(() => {
        // window.location.href = '/login'
      });
    }
    Message({
      message,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  },
);

export default service;
